// extracted by mini-css-extract-plugin
module.exports = {"InsideContainer":"InsideContainer_qviy-","ShowEntersAndTabs":"ShowEntersAndTabs_9+7Ol"};